import styled from "@emotion/styled";

import { NewsletterArticleHeader } from "./header";
import { NewsletterArticleIssues } from "./issues";

export const Container = styled.div`
  padding-block-start: 40px;
  padding-block-end: 49px;
`;

export const StyledNewsletterArticleHeader = styled(NewsletterArticleHeader)`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-inline-start: 0;
  margin-inline-end: 0;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-inline: 79px;
  }
`;

export const StyledNewsletterArticleIssues = styled(NewsletterArticleIssues)``;

export const ShareContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-block-end: 20px;
`;

export const CommentTrigger = styled.span`
  flex: 1;

  ${props => props.theme.breakpoints.up("tablet")} {
    max-inline-size: 335px;
  }
`;

export const ShareWidget = styled.span`
  display: none;
  ${props => props.theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const AuthorDetail = styled.div`
  margin-block-end: 8px;
`;
